import React, { Component } from 'react';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import update from 'immutability-helper';

class NewUser extends Component {
    constructor() {
        super();

        this.Configurations = new Configurations();

        this.handleChange = this.handleChange.bind(this);
        this.addUser = this.addUser.bind(this);
        this.handleCheckAccess = this.handleCheckAccess.bind(this);

        this.state = {
            user: {
                name: "",
                username: "",
                email: "",
                password: "",
            },
            isLoading: false,
        }
    }

    componentDidMount() {
        axios.get(this.Configurations.apiBasePath + `/usuario/lista-permissoes`).then(response => {
            this.setState({
                permissoes: response.data.permissoes
            })
        }).catch(err => {
        });
    }

    handleChange(e) {
        // If you are using babel, you can use ES 6 dictionary syntax
        // let change = { [e.target.name] = e.target.value }
        let change = this.state.user;
        change[e.target.name] = e.target.value
        this.setState({ "user": change })
    }

    _validateForm() {
        let _valid = true;
        for (let key in this.state.user) {
            if (this.state.user[key].trim() === "") {
                _valid = false;
                break;
            }
        }

        return _valid;
    }

    addUser() {
        if (this._validateForm() && (this.state.permissoes.filter(item => item.checked).length > 0)) {
            this.setState({ isLoading: true });
            const _params = {
                "usuario": {
                    "nome": this.state.user.name,
                    "login": this.state.user.username,
                    "email": this.state.user.email,
                    "senha": this.state.user.password,
                    "permissoes": this.state.permissoes.filter(item => item.checked).map((perm, index) => {
                        return perm.idPermissao
                    })
                }
            }
            const _service = axios.post(this.Configurations.apiBasePath + `/usuario/adicionar`, _params);

            _service.then(response => {
                this.props.close();
                this.props.refresh();
                this.setState({ isLoading: false });
            }).catch(err => {
                this.setState({ isLoading: false });
            });
        } else {
            alert('Preencha todos os campos');
        }
    }

    handleCheckAccess(e) {
        const _index = this.state.permissoes.findIndex(item => item.idPermissao === parseInt(e.target.value, 10));
        this.setState({ permissoes: update(this.state.permissoes, { [_index]: { checked: { $set: !this.state.permissoes[_index].checked } } }) })
    }

    render() {
        return (
            <div className="new-user">
                <div className="row">
                    <div className="col-12">
                        <h3 className="title-2">Novo usuário</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label htmlFor="txtName">
                                                Nome completo
                                            </label>
                                            <input id="txtName" className="form-control" autoComplete="off" name="name" type="text" value={this.state.user.name} placeholder="Nome completo" onChange={this.handleChange} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label htmlFor="txtEmail">
                                                E-mail
                                            </label>
                                            <input id="txtEmail" className="form-control" autoComplete="off" name="email" type="email" value={this.state.user.email} placeholder="usuario@dominio.com.br" onChange={this.handleChange} />
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label htmlFor="txtUsername">
                                                Nome de usuário
                                            </label>
                                            <input id="txtUsername" autoComplete="off" className="form-control" name="username" type="text" value={this.state.user.username} placeholder="Nome de usuário" onChange={this.handleChange} />
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-group">
                                            <label htmlFor="txtPassword">
                                                Senha
                                            </label>
                                            <input id="txtPassword" className="form-control" name="password" type="password" value={this.state.user.password} placeholder="**********" onChange={this.handleChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <p>Selecione as permissões do usuário:</p>
                                    </div>

                                    <div className="col-12">
                                        <div className="row d-flex">
                                            {/* <div className="col-12">
                                                {this.state.permissoes && (
                                                    <ul>
                                                        {this.state.permissoes.map((item, index) => {
                                                            return <div key={index} className="form-check">
                                                                <input className="form-check-input" type="checkbox" name="access-level" id={index} checked={item.checked} value={item.idPermissao} onChange={this.handleCheckAccess} />
                                                                <label className="form-check-label" htmlFor="unitario">{item.idPermissao} - {item.nome}: {item.descricao}</label>
                                                            </div>
                                                        })}
                                                    </ul>
                                                )}
                                            </div> */}

                                            <div className="col-6">
                                                <h3 className='conteudo-title'>Conteúdo</h3>
                                                <ul className='column-permissoes'>
                                                    {this.state.permissoes && this.state.permissoes.filter(i => i.idCategoriaAcesso === 4).map((item, index) => {
                                                        return <div key={index} className="form-check">
                                                            <input className="form-check-input" type="checkbox" name="access-level" id={`${item.idPermissao}`} checked={item.checked || item.checked === "true"} value={item.idPermissao} onChange={this.handleCheckAccess} />
                                                            <label className="form-check-label" htmlFor="unitario"> {item.nome}: {item.descricao}</label>
                                                        </div>
                                                    })}
                                                </ul>
                                            </div>

                                            <div className="col-6">
                                                <h3 className='operacoes-title'>Operações</h3>
                                                <ul className='column-permissoes'>
                                                    {this.state.permissoes && this.state.permissoes.filter(i => i.idCategoriaAcesso === 3).map((item, index) => {
                                                        return <div key={index} className="form-check">
                                                            <input className="form-check-input" type="checkbox" name="access-level" id={`${item.idPermissao}`} checked={item.checked || item.checked === "true"} value={item.idPermissao} onChange={this.handleCheckAccess} />
                                                            <label className="form-check-label" htmlFor="unitario"> {item.nome}: {item.descricao}</label>
                                                        </div>
                                                    })}
                                                    {this.state.permissoes && this.state.permissoes.filter(i => i.idCategoriaAcesso === 8).map((item, index) => {
                                                        return <div key={index} className="form-check">
                                                            <input className="form-check-input" type="checkbox" name="access-level" id={`${item.idPermissao}`} checked={item.checked || item.checked === "true"} value={item.idPermissao} onChange={this.handleCheckAccess} />
                                                            <label className="form-check-label" htmlFor="unitario"> {item.nome}: {item.descricao}</label>
                                                        </div>
                                                    })}
                                                    {this.state.permissoes && this.state.permissoes.filter(i => i.idCategoriaAcesso === 9).map((item, index) => {
                                                        return <div key={index} className="form-check">
                                                            <input className="form-check-input" type="checkbox" name="access-level" id={`${item.idPermissao}`} checked={item.checked || item.checked === "true"} value={item.idPermissao} onChange={this.handleCheckAccess} />
                                                            <label className="form-check-label" htmlFor="unitario"> {item.nome}: {item.descricao}</label>
                                                        </div>
                                                    })}
                                                </ul>
                                                <ul className='column-permissoes'>
                                                    {this.state.permissoes && this.state.permissoes.filter(i => i.idCategoriaAcesso === 6).map((item, index) => {
                                                        return <div key={index} className="form-check">
                                                            <input className="form-check-input" type="checkbox" name="access-level" id={`${item.idPermissao}`} checked={item.checked || item.checked === "true"} value={item.idPermissao} onChange={this.handleCheckAccess} />
                                                            <label className="form-check-label" htmlFor="unitario"> {item.nome}: {item.descricao}</label>
                                                        </div>
                                                    })}
                                                    {this.state.permissoes && this.state.permissoes.filter(i => i.idCategoriaAcesso === 10).map((item, index) => {
                                                        return <div key={index} className="form-check">
                                                            <input className="form-check-input" type="checkbox" name="access-level" id={`${item.idPermissao}`} checked={item.checked || item.checked === "true"} value={item.idPermissao} onChange={this.handleCheckAccess} />
                                                            <label className="form-check-label" htmlFor="unitario"> {item.nome}: {item.descricao}</label>
                                                        </div>
                                                    })}
                                                </ul>
                                            </div>

                                            <div className="col-6 pt-2">
                                                <h3 className='cadastro-title'>Atendimento</h3>
                                                <ul className='column-permissoes'>
                                                    {this.state.permissoes && this.state.permissoes.filter(i => i.idCategoriaAcesso === 7).map((item, index) => {
                                                        return <div key={index} className="form-check">
                                                            <input className="form-check-input" type="checkbox" name="access-level" id={`${item.idPermissao}`} checked={item.checked || item.checked === "true"} value={item.idPermissao} onChange={this.handleCheckAccess} />
                                                            <label className="form-check-label" htmlFor="unitario"> {item.nome}: {item.descricao}</label>
                                                        </div>
                                                    })}
                                                </ul>
                                                <ul className='column-permissoes'>
                                                    {this.state.permissoes && this.state.permissoes.filter(i => i.idCategoriaAcesso === 2).map((item, index) => {
                                                        return <div key={index} className="form-check">
                                                            <input className="form-check-input" type="checkbox" name="access-level" id={`${item.idPermissao}`} checked={item.checked || item.checked === "true"} value={item.idPermissao} onChange={this.handleCheckAccess} />
                                                            <label className="form-check-label" htmlFor="unitario"> {item.nome}: {item.descricao}</label>
                                                        </div>
                                                    })}
                                                </ul>
                                            </div>
                                            <div className="col-6 pt-2">
                                                <h3 className='admin-title'>Admin</h3>
                                                <ul className='column-permissoes'>
                                                    {this.state.permissoes && this.state.permissoes.filter(i => i.idCategoriaAcesso === 1).map((item, index) => {
                                                        return <div key={index} className="form-check">
                                                            <input className="form-check-input" type="checkbox" name="access-level" id={`${item.idPermissao}`} checked={item.checked || item.checked === "true"} value={item.idPermissao} onChange={this.handleCheckAccess} />
                                                            <label className="form-check-label" htmlFor="unitario"> {item.nome}: {item.descricao}</label>
                                                        </div>
                                                    })}
                                                </ul>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 text-right">
                                        {this.state.isLoading ? (
                                            <div className="spinner-border text-primary" />
                                        ) : (
                                            <>
                                                <button className="btn btn-danger" onClick={this.props.close}>Cancelar</button>
                                                <button className="btn btn-success" onClick={this.addUser}>Adicionar</button>
                                            </>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default NewUser;
